export enum StagePosition {
  ALL,
  LEFT,
  RIGHT,
  DEFAULT,
}
